import { use$, useObserve } from '@legendapp/state/react';
import { useRef } from 'react';
import { manualBetState$ } from '../../../state';
import { PredefinedBets } from '../PredefinedBets';

export const ManualBetPredefinedBets = () => {
  const betAmount = use$(manualBetState$.betAmount);
  const lastClickedBetRef = useRef<number | null>(null);
  const internalUpdateRef = useRef(false);

  useObserve(manualBetState$.betAmount, () => {
    if (internalUpdateRef.current) {
      internalUpdateRef.current = false;
      return;
    }
    lastClickedBetRef.current = null;
  });

  const handlePredefinedBetClick = (bet: number) => {
    internalUpdateRef.current = true;

    if (lastClickedBetRef.current === bet) {
      manualBetState$.setBetAmount(betAmount + bet);
    } else {
      manualBetState$.setBetAmount(bet);
      lastClickedBetRef.current = bet;
    }
  };

  return <PredefinedBets onClick={handlePredefinedBetClick} />;
};
